import { createContext, useContext } from "react";
import type { EnquirySiteVisit } from "../types/enquiry-site-visit.types";

interface EnquirySiteVisitOverviewContextType {
  enquirySiteVisit: EnquirySiteVisit | null;
  refetch: () => Promise<void>;
}

const EnquirySiteVisitOverviewContext =
  createContext<EnquirySiteVisitOverviewContextType | null>(null);

export const useEnquirySiteVisitOverview = () => {
  const context = useContext(EnquirySiteVisitOverviewContext);
  if (!context) {
    throw new Error("useEnquirySiteVisitOverview must be used within provider");
  }
  return context;
};

export default EnquirySiteVisitOverviewContext;
